import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingControlWidgetWidget } from '../../../../../services/ControlWidgetService.service';




@Component({
  selector: 'text-input-control-widget-menu-settings',
  templateUrl: 'text-input-control-widget-menu-settings.component.html',
  styleUrls: ['./text-input-control-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class TextInputControlWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  constructor(

  ) {


  }
    ngOnInit(): void {
      
    }


}



